import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { brandData, stats, images } from '../data/mock';

const HeroSection = ({ onRequestQuote }) => {
  const scrollToProducts = () => {
    const element = document.querySelector('#products');
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      {/* Hero Image */}
      <div className="hero-image-container">
        <img 
          src={images.hero} 
          alt={images.heroAlt}
          className="hero-image"
          loading="eager"
        />
      </div>

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
          <div className="py-12 lg:py-0">
            <p 
              className="body-small mb-4"
              style={{ 
                textTransform: 'uppercase', 
                letterSpacing: '0.2em',
                color: 'var(--accent-red)',
                fontWeight: 600
              }}
            >
              {brandData.positioning_phrase}
            </p>
            <h1 className="hero-large mb-6">
              Precision fasteners for <br/>
              <span style={{ color: 'var(--accent-teal)' }}>OEMs & Tier-1</span> suppliers
            </h1>
            <p className="body-large mb-8" style={{ maxWidth: '500px' }}>
              High-quality fastening solutions trusted by India's leading brands. 
              45+ years of manufacturing excellence with 1M+ pieces daily capacity.
            </p>
            <div className="flex flex-wrap gap-4 mb-12">
              <button className="btn-primary" onClick={onRequestQuote}>
                Request a Quote
                <ArrowRight size={16} />
              </button>
              <button className="btn-secondary" onClick={scrollToProducts}>
                View Products
              </button>
            </div>

            {/* Stats inline */}
            <div className="flex flex-wrap gap-8 pt-8 border-t" style={{ borderColor: 'var(--border-light)' }}>
              {stats.slice(0, 3).map((stat, index) => (
                <div key={index}>
                  <div className="text-3xl font-light" style={{ color: 'var(--text-primary)' }}>
                    {stat.value}<span style={{ color: 'var(--accent-red)' }}>{stat.suffix}</span>
                  </div>
                  <div className="text-xs uppercase tracking-wider mt-1" style={{ color: 'var(--text-light)' }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div 
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 hidden lg:block"
          style={{ animation: 'bounce 2s infinite' }}
        >
          <button 
            onClick={scrollToProducts}
            className="bg-transparent border-none cursor-pointer p-2"
            aria-label="Scroll down"
          >
            <ChevronDown size={24} color="var(--text-light)" />
          </button>
        </div>
      </div>

      <style>{`
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0) translateX(-50%); }
          40% { transform: translateY(-10px) translateX(-50%); }
          60% { transform: translateY(-5px) translateX(-50%); }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
